// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import {
  type MarketSummary,
  type MarketSummaryWireFormat,
  NewMarketSummary,
} from '../MarketSummary/MarketSummary';
import { NewRole, type Role, type RoleWireFormat } from '../Role/Role';

export class User {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string | null;
  readonly emailAddress: string;
  readonly phoneNumber: string | null;
  readonly canReceiveEmail: boolean;
  readonly isDeactivated: boolean;
  readonly allMarkets: boolean;
  readonly externalID: string | null;
  readonly roles: Role[];
  readonly permissions: Enums.Permission[];
  readonly userPermissions: Enums.Permission[];
  readonly marketSummaries: MarketSummary[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.firstName = data.firstName === undefined ? '' : data.firstName;
    this.lastName = data.lastName === undefined ? null : data.lastName;
    this.emailAddress = data.emailAddress === undefined ? '' : data.emailAddress;
    this.phoneNumber = data.phoneNumber === undefined ? null : data.phoneNumber;
    this.canReceiveEmail = data.canReceiveEmail === undefined ? false : data.canReceiveEmail;
    this.isDeactivated = data.isDeactivated === undefined ? false : data.isDeactivated;
    this.allMarkets = data.allMarkets === undefined ? false : data.allMarkets;
    this.externalID =
      // eslint-disable-next-line no-nested-ternary
      (data.externalID ?? null) === null
        ? null
        : data.externalID === undefined
          ? ''
          : data.externalID;
    this.roles = (data.roles ?? []).map((roles: any) => NewRole(roles));
    this.permissions = (data.permissions ?? []).map((permissions: any) =>
      permissions === undefined ? Enums.Permission.ViewCostData : permissions,
    );
    this.userPermissions = (data.userPermissions ?? []).map((userPermissions: any) =>
      userPermissions === undefined ? Enums.Permission.ViewCostData : userPermissions,
    );
    this.marketSummaries = (data.marketSummaries ?? []).map((marketSummaries: any) =>
      NewMarketSummary(marketSummaries),
    );
  }

  static zero(): User {
    const zeroValues: ExcludeMethodsDeep<User> = {
      id: NIL_UUID,
      firstName: '',
      lastName: null,
      emailAddress: '',
      phoneNumber: null,
      canReceiveEmail: false,
      isDeactivated: false,
      allMarkets: false,
      externalID: null,
      roles: [],
      permissions: [],
      userPermissions: [],
      marketSummaries: [],
    };
    return new User(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  fullName(): string {
    return `${this.firstName}${this.lastName === null ? '' : ` ${this.lastName}`}`;
  }

  /**
   * isSelectable decides if this user is able to be selected in either
   * a dropdown, lookup, or multi-lookup component.
   */
  isSelectable(): boolean {
    if (this.firstName === 'Slabstack' && this.lastName === 'Admin') {
      return false;
    }
    if (this.isDeactivated) {
      return false;
    }
    return true;
  }

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UserWireFormat = {
  id: string;
  firstName: string;
  lastName: string | null;
  emailAddress: string;
  phoneNumber: string | null;
  canReceiveEmail: boolean;
  isDeactivated: boolean;
  allMarkets: boolean;
  externalID: string | null;
  roles: RoleWireFormat[];
  permissions: string[];
  userPermissions: string[];
  marketSummaries: MarketSummaryWireFormat[];
};

type NewUserProps = PartialDeep<User, { recurseIntoArrays: true }>;
export const NewUser: (props: NewUserProps) => User = (props) => new User(props);

type NewUserFromWireFormatProps = PartialDeep<UserWireFormat, { recurseIntoArrays: true }>;
export const NewUserFromWireFormat: (props: NewUserFromWireFormatProps) => User = (props) =>
  new User(props);
